import { useQuery } from "react-query";
import {
  FrequentPassageRequest,
  Material,
  MaterialRequest,
  Options,
  QueryListResult
} from "../utils/types";
import {getRegistrationFrequentPassageRequests} from "../../../services/api/registrationFrequentPassageRequests";

export const REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY = "Q_REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL";
export type UseFrequentPassageRequestsType = Options;

export const useRegistrationFrequentPassageRequests = (
  registrationId: number,
  options: UseFrequentPassageRequestsType = { include: "crewMember.user,registration.company" }
) => {
  let { page, size, sort, include, ...rest } = options;

  if (!page) page = 0;
  if (!size) size = 50;
  if (!sort) sort = "-created_at";

  const filters = {
    "page[number]": page,
    "page[size]": size,
    sort,
    include,
    ...rest
  };
  return useQuery<QueryListResult<FrequentPassageRequest>>(
    [REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY, registrationId, page, size, sort, include],
    () => getRegistrationFrequentPassageRequests(registrationId, filters)
  );
};
